import { BrowserRouter, Route, Routes } from "react-router";

// Toolkit imports
import { ApiCacheProvider } from "sj-ui-toolkit/src/api/cache";
import { CookieConsent } from "sj-ui-toolkit/src/atlas/components";
import { LearnAppRoutes } from "sj-ui-toolkit/src/constants/routes";
import { useSegment } from "sj-ui-toolkit/src/hooks";
import { ErrorPage } from "sj-ui-toolkit/src/atlas/components/ErrorPage/ErrorPage";
import { SettingsContextProvider } from "sj-ui-toolkit/src/atlas/contexts/Settings/SettingsContextProvider";

// Context
import { LearnContextProvider } from "./context/LearnContext.jsx";

// Shared layout
import Layout from "./components/Layout/Layout.jsx";

// Route components
import Dashboard from "./components/Dashboard/Dashboard.jsx";
import LessonPage from "./components/Lesson/LessonPage.jsx";
import ExercisePage from "./components/Exercise/ExercisePage.jsx";
import Path from "./components/Path/Path.jsx";
import TournamentPage from "./components/Tournament/TournamentPage.jsx";
import TournamentContentPage from "./components/Tournament/TournamentContentPage.jsx";

// Guest access component
import GuestLessonAccess from "./components/Guest/GuestLessonAccess.jsx";
import Catalog from "./components/Catalog/Catalog.jsx";
import TestConnection from "./components/TestConnection/TestConnection.jsx";
import FeedbackPage from "./components/Feedback/FeedbackPage.jsx";
import LeaderboardPage from "./components/Leaderboard/LeaderboardPage.jsx";
import { LearnNavigationProvider } from "./context/LearnNavigationContext.jsx";

function App() {
  useSegment();
  return (
    <BrowserRouter>
      <CookieConsent />
      <ApiCacheProvider>
        <LearnContextProvider>
          <SettingsContextProvider>
            <LearnNavigationProvider>
              <Routes>
                <Route path={LearnAppRoutes.route} element={<Layout />}>
                  <Route index element={<Dashboard />} />
                  <Route path={LearnAppRoutes.routes.catalog.route} element={<Catalog />} />
                  <Route path={LearnAppRoutes.routes.lesson.route} element={<LessonPage />} />
                  <Route path={LearnAppRoutes.routes.exercise.route} element={<ExercisePage />} />
                  <Route
                    path={LearnAppRoutes.routes.testConnection.route}
                    element={<TestConnection />}
                  />
                  <Route path={LearnAppRoutes.routes.path.route} element={<Path />} />
                  <Route
                    path={LearnAppRoutes.routes.quest.route}
                    element={<Path pathType={"Quest"} />}
                  />
                  <Route
                    path={LearnAppRoutes.routes.tournaments.routes.details.route}
                    element={<TournamentPage />}
                  />
                  <Route
                    path={LearnAppRoutes.routes.tournaments.routes.content.route}
                    element={<TournamentContentPage />}
                  />
                  <Route path={LearnAppRoutes.routes.feedback.route} element={<FeedbackPage />} />
                  <Route
                    path={LearnAppRoutes.routes.leaderboard.route}
                    element={<LeaderboardPage />}
                  />

                  {/** SCORM Route -> Routes to LessonPage **/}
                  <Route path={LearnAppRoutes.routes.scorm.route} element={<LessonPage />} />
                  <Route
                    path="*"
                    element={
                      <ErrorPage
                        redirectRoute={LearnAppRoutes.route}
                        buttonText="Go to Dashboard"
                        automaticRedirect={false}
                      />
                    }
                  />
                </Route>
                {/** Guest Access is outside of the Layout **/}
                <Route path={LearnAppRoutes.routes.guest.route} element={<GuestLessonAccess />} />
              </Routes>
            </LearnNavigationProvider>
          </SettingsContextProvider>
        </LearnContextProvider>
      </ApiCacheProvider>
    </BrowserRouter>
  );
}

export default App;
